import { cloneDeep } from "lodash";
import {FILE_SIZES} from "../../../../constants/file-sizes.constant";

export const PrintLayoutController = ($scope, $mdDialog, callback, company, overlay, bleed, photos, startScreenDesign, background, logo, showLogo, logosArr) => {
    "ngInject";

    // if json provided than clone configuration
    $scope.sourceConfig && ($scope.configuration.json = $scope.sourceConfig.json);
    $scope.callback = callback;
    $scope.company = company;
    $scope.overlay = overlay;
    $scope.bleed = bleed;
    $scope.photos = photos;
    $scope.startScreenDesign = startScreenDesign;
    $scope.background = background;
    $scope.savedFile = $scope.startScreenDesign ? cloneDeep($scope.background.file) : null;
    $scope.savedColor = $scope.startScreenDesign ? cloneDeep($scope.background.color) : null;
    $scope.logo = logo;
    $scope.showLogo = $scope.startScreenDesign ? showLogo : false;
    $scope.logosArr = logosArr;
    $scope.fileSizes = FILE_SIZES;

    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.create = () => {
        let data = {
            overlay: $scope.overlay,
            bleed: $scope.bleed,
            startScreenDesign: $scope.startScreenDesign
        };
        $scope.callback(data);
        $mdDialog.hide();
    };

    $scope.deleteFile = () => {
        $scope.overlay = null;
    };

    $scope.onChangeOption = () => {
          if ($scope.startScreenDesign) {
              $scope.savedFile = cloneDeep($scope.background.file);
              $scope.savedColor = cloneDeep($scope.background.color);
              $scope.showLogo = true;
          } else {
              $scope.savedFile = null;
              $scope.savedColor = null;
              $scope.showLogo = false;
          }
    };
};


// WEBPACK FOOTER //
// ./sources/components/configurations/quick-setup/print-layout/print-layout.js